import $ from 'jquery';

export default () => {
    $(document).on('click', '.btn-display-list-form', function() {
        $(this).parents('.modal-product-list').find('form').removeClass('d-none');
        $(this).remove();
    })

    $('.collapse').on('show.bs.collapse', function (e) {
        const list = $(this);
        const listBody = list.find('.card-body');
        const listId = this.dataset.listid;

        if (listBody && listId) {
            $.ajax({
                type: 'POST',
                url: '/list/products?list_id=' + listId,
                success: (data) => {
                    listBody.html(data);
                },
                error: function (e) {
                    console.log('Error.', e);
                }
            })
        }
    })

    $('.collapse').on('hide.bs.collapse', function (e) {
        const list = $(this);
        const listBody = list.find('.card-body');
        listBody.html('');
    })

    $(document).on('submit', '.form-add-to-list, .form-create-list', function(e) {
        e.preventDefault();
        const $form = $(this);
        $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            data: $form.serialize(),
            success: (data) => {
                $form.find('button[type="submit"]').text('ok').prop('disabled', true);
            },
            error: function (e) {
                console.log('Error.', e);
            }
        })
        return false;
    })

    $(document).on('change', '.form-list-update',  function(e) {

        const form = $(this);
        const url = form.attr('action');
        const container = $(this).parents('.collapse');


        container.addClass('card-mask');

        $.ajax({type: "POST", data: form.serialize() , url,
            success: function(data){
                const newContent = $(data).find(`#${container.attr('id')} .card-body`);
                container.find('.card-body').replaceWith(newContent)
                container.removeClass('card-mask');
            },
            error: function (e) {
                console.log('Error.', e);
            }
        });

    })

    $(document).on('click.form-list-update', '.form-list-update button' , function(e) {
        e.preventDefault();
        const type = $(this).data('qty');
        const form = $(this).parents('form');
        const url = form.attr('action');
        const container = $(this).parents('.collapse');
        const quantityInput = form.find('input[name="gpb_list_product[quantity]"]')
        let quantity = parseInt(quantityInput.val(), 10);

        const quantityStep = +quantityInput.attr('step') || 100;
        const quantityMin = +quantityInput.attr('min') || 100;
        const quantityMax = +quantityInput.attr('max') || 5000;

        if (!type ||!quantity) return;

        switch (type) {
            case 'minus':
                if ((quantity - quantityStep) < quantityMin) {
                    quantity = quantityMin
                } else {
                    quantity = quantity - quantityStep
                }
                break;
            case 'plus':
                if ((quantity + quantityStep) > quantityMax) {
                    quantity = quantityMax;
                } else {
                    quantity = quantity + quantityStep
                }
                break;
            default:
                break;
        }

        console.log(quantity, quantityInput.val())
        quantityInput.val(quantity);
        console.log(quantityInput.val(), form.serialize())
        container.addClass('card-mask');

        $.ajax({type: "POST", data: form.serialize() , url,
            success: function(data){
                const newContent = $(data).find(`#${container.attr('id')} .card-body`);
                container.find('.card-body').replaceWith(newContent)
                container.removeClass('card-mask');
            },
            error: function (e) {
                console.log('Error.', e);
            }
        });

        return false;
    })
}


// WEBPACK FOOTER //
// ./assets/src/js/modules/QuickAddList.js